/* eslint-disable max-len */

const CHEAP_STORAGE_DATA = [
	{
		heading: "Cheap Self Storage Units Near You",
		description:
			"Nobody likes to purchase something without making sure they're getting a good deal. When searching for a storage unit, it's the same story. Many storage users choose a specific storage facility based largely on the price, so it's undoubtedly an important factor in most decision. Whether you are a college student stashing your stuff over the summer, or a retired couple downsizing into a smaller home, not paying too much for a self storage unit is extremely important. "
	},
	{
		heading: "Self Storage Pricing",
		description:
			"When trying to find cheap storage, it is important to understand the factors that go into self storage pricing.",
		subHeadings: [
			{
				title: "Location",
				desc: "Just as it is with apartments, condos, and houses, location is a key factor in self storage prices. If you're looking for a storage unit in a heavily populated area (like the downtown area of a large city), prices may be higher than those on the outskirts of town."
			},
			{
				title: "Features",
				desc: "Prices can vary depending on the storage amenities provided by the self-storage facility. For example: A climate-controlled or alarmed storage unit is going to cost more than a standard unit."
			},
			{
				title: "Facility Age",
				desc: "Some facilities are nicer than others, and this will usually have an effect on price range. Better facilities, like better hotels, will charge higher rates than an old, outdated facility. Basically, if you want the best, you will have to pay for it. However, an inexpensive storage facility oftentimes is just as good as a pricier self-storage facility in a prime location."
			},
			{
				title: "Seasonal Demand",
				desc: "There are certainly times of the year where storage units are in high demand, like the summer months when people have more belongings to place in storage. Whenever demand increases, the chances of finding a great deal with decrease. Traditionally, self storage demand tends to spike between May and September when people are moving the most, including college students and families."
			}
		]
	},
	{
		heading: "Average Storage Unit Prices",
		description:
			"If you want to know if you are getting a good deal, it may help to compare the rates provided by storage facilities near you to the average price nationwide.",
		description2:
			"​Below are the national average asking prices for self-storage units by size:",
		points: [
			{
				title: "5x5 storage unit prices: ",
				desc: "$44.81 per month"
			},
			{
				title: "5x10 storage unit prices: ",
				desc: "$63.05 per month"
			},
			{
				title: "10x10 storage unit prices: ",
				desc: "$97.40 per month"
			},
			{
				title: "10x15 storage unit prices: ",
				desc: "$124.07 per month"
			},
			{
				title: "10x20 storage unit prices: ",
				desc: "$146.14 per month"
			}
		]
	},
	{
		heading: "How to Save Money on Storage",
		subHeadings: [
			{
				title: "Choose the right unit size",
				descLink: {
					contentBefore:
						"You don't want to overpay for space you don't use. That's why it's important to rent a unit that's just right for your storage needs. If you need help visualizing how much space you'll need for your belongings, you can use our ",
					linkText: "storage unit size guide.",
					link: "#"
				}
			},
			{
				title: "Don't get unnecessary features",
				desc: "The fewer amenities you have, the cheaper your storage unit will be. While features like drive-up access make using storage more convenient since you don't have to carry your items through doorways or up flights of stairs, you may not need it."
			},
			{
				title: "Climate Control",
				desc: "On average, climate controlled self storage units cost about 30% more than a self storage unit without climate control. If you aren't too worried about the off-chance that extreme heat or humidity damages your goods, then a traditional storage unit without climate control will save you some money."
			},
			{
				title: "Look for automated facilities",
				desc: "You might save money renting from an unmanned, automated facility. These storage locations do not have regular staff on the premises, and all business is conducted online or through a kiosk with a credit card. Another benefit is that these facilities often offer 24-hour access. Because they do not have paid staff to serve customers, they can typically charge a little bit less."
			},
			{
				title: "Rent during non-peak seasons",
				desc: "Since there's a strong connection between price and seasonal demand, you can save a few dollars by signing a rental agreement during non-peak seasons. Certain storage unit sizes might also have different seasons. For example, large units might be more expensive in resort areas due to increased demand for RV storage and boat storage."
			},
			{
				title: "Search for online specials",
				desc: "Use advertisements or online storage directories to find special offers for self storage in your area. A lot of storage facilities offer special rates to those who rent online, such as the 1st month free or $1 dollar first month rent."
			}
		]
	},
	{
		heading: "Cheap Storage FAQ",
		subHeadings: [
			{
				title: "How do I find cheap storage units near me?",
				desc: "To find cheap storage units near you, put your zip code into Storage.com and instantly find prices for self storage facilities near you. find the storage facility with the lowest price and reserve your unit online for free."
			},
			{
				title: "Do I need self-storage insurance?",
				desc: "Self-storage insurance can add to the monthly cost of a self storage unit, and it is not typically included in the price. Often your renters insurance or homeowners insurance poly will cover your items in storage, so you may not need to pay extra for the insurance offered by the self-storage facility. check with your insurance carrier to make sure you are covered."
			},
			{
				title: "How much is a small storage unit?",
				desc: "The smallest storage unit you will typically find is a 5x5, which should cost between $30 and $50 a month."
			}
		]
	}
	// {
	// 	heading: "Popular Cities For Self Storage",
	// 	popularCities: true
	// }
];

export { CHEAP_STORAGE_DATA };
